// The Criar conta form's input checks (SPEC-14, Action list). They spare
// the athlete a round trip; the server checks again: Firebase Auth refuses
// a malformed email, and saveProfile refuses a first name the lib's
// profileErrors rejects. The password rule has no server twin yet
// (poweryourflow-ops/docs/bugs.md).

import { LIMITS } from "../schema/types";

export const PASSWORD_MIN_LENGTH = 8;

export interface SignUpDraft {
  firstName: string;
  email: string;
  password: string;
}

export const EMPTY_DRAFT: SignUpDraft = { firstName: "", email: "", password: "" };

export type FieldError = "firstNameEmpty" | "firstNameTooLong" | "emailInvalid" | "passwordInvalid";

export type FieldErrors = Partial<Record<keyof SignUpDraft, FieldError>>;

/** What is sent: the first name without surrounding spaces, the email trimmed and in lower case. */
export function normalize(draft: SignUpDraft): SignUpDraft {
  return { firstName: draft.firstName.trim(), email: draft.email.trim().toLowerCase(), password: draft.password };
}

/** "Continuar" is active once no field is empty; the full check runs on the tap. */
export const canSubmit = (draft: SignUpDraft): boolean =>
  draft.firstName !== "" && draft.email !== "" && draft.password !== "";

// One "@", something on each side, a dot in the domain, no spaces. Firebase
// Auth has the final word.
const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/** The shape check of an email, already trimmed; Entrar's "Esqueci-me" uses it too (SPEC-15). */
export const emailLooksValid = (email: string): boolean => EMAIL.test(email);

/** 8 characters and a digit; the new password of a reset follows the same rule (SPEC-15). */
export const passwordMeetsRule = (password: string): boolean =>
  password.length >= PASSWORD_MIN_LENGTH && /\d/.test(password);

/** The errors of a normalized draft, by field; empty when it may be sent. */
export function fieldErrors(draft: SignUpDraft): FieldErrors {
  const errors: FieldErrors = {};
  if (draft.firstName === "") errors.firstName = "firstNameEmpty";
  else if (draft.firstName.length > LIMITS.FIRST_NAME_MAX) errors.firstName = "firstNameTooLong";
  if (!emailLooksValid(draft.email)) errors.email = "emailInvalid";
  if (!passwordMeetsRule(draft.password)) errors.password = "passwordInvalid";
  return errors;
}
